import type { SettingsSearchRow } from "../settings-search-types";

/** Anchor ids for the Appearance page's rows — imported by BOTH the page
 *  (to place `SettingsHighlightTarget`s) and the search catalog, so a jump
 *  can never name a row the page doesn't mark. */
export const APPEARANCE_ANCHORS = {
  theme: "theme",
} as const;

export const APPEARANCE_SEARCH_ROWS: readonly SettingsSearchRow[] = [
  {
    anchor: APPEARANCE_ANCHORS.theme,
    label: "Theme",
    keywords: ["dark mode", "light mode", "appearance", "color", "accent", "contrast"],
  },
];
